export const multiplePromiseSettler = <T extends PromiseSettledResult<unknown>[]>(
	results: T,
): T => {
	if (results.length > 0) {
		const error = results.find((result) => result.status === 'rejected');
		if (error) {
			throw 'reason' in error
				? error.reason
				: new Error('Unknown error occurred during fetch resource');
		}

		return results;
	}
	return results;
};
